import { REDUCERS } from '@/constants/reducers';

export function app(state, action) {
    let app = { ...state.app };
    switch (action.type) {
        case REDUCERS.UPDATE_APP:
            return { ...state, app: { ...app, ...action.payload } };
        case REDUCERS.SHOW_SPINNER:
            return { ...state, app: { ...app, isSpinnerVisible: true } };
        case REDUCERS.HIDE_SPINNER:
            return { ...state, app: { ...app, isSpinnerVisible: false } };
        case REDUCERS.UPDATE_COOKIES_ACCEPTED:
            return { ...state, cookiesAccepted: action.payload };
        default:
            return state;
    }
}
